import request from '@/utils/request';

//获取消息内容
export function getMessageNotice(data) {
  return request({
    url: '/adminapi/message-notice',
    method: 'get',
    params: data
  });
}

export function getMessageNoticeColumn(data) {
  return request({
    url: '/adminapi/message-notice/column',
    method: 'get',
    params: data
  });
}

export function getMessageNoticeColumnValue(data) {
  return request({
    url: '/adminapi/message-notice/column/value',
    method: 'get',
    params: data
  });
}
//获取用户最新的消息
export function getMessageNoticeLatest(data) {
  return request({
    url: '/adminapi/message-notice/latest',
    method: 'get',
    requestType: 'message_notice',
    params: data
  });
}
export function postMessageNoticeData(data) {
  return request({
    url: '/adminapi/message-notice/data',
    method: 'post',
    data
  });
}
export function postMessageMarkReadByUid(data) {
  return request({
    url: '/adminapi/message-notice/markRead/ByUid',
    method: 'post',
    data
  });
}
